var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_13721",
    "data-name": "Group 13721",
    transform: "translate(-4811.5 -2594)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(4811.5 2594)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12293",
    "data-name": "Group 12293",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4499",
    "data-name": "Rectangle 4499",
    width: 35,
    height: 35,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "home-2",
    "data-name": "home",
    transform: "translate(2.856 4.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11944",
    "data-name": "Group 11944",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11943",
    "data-name": "Group 11943",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5534",
    "data-name": "Path 5534",
    d: "M14.068,12.1h0a2.251,2.251,0,0,1,1.518.59L27.973,23.978A2.254,2.254,0,0,1,26.455,27.9h-1.14v10.47a1.652,1.652,0,0,1-1.65,1.65H16.875a1.652,1.652,0,0,1-1.65-1.65V32.34H12.911v6.028a1.652,1.652,0,0,1-1.65,1.65H4.471a1.652,1.652,0,0,1-1.65-1.65V27.9H1.681a2.254,2.254,0,0,1-1.518-3.92L12.549,12.691A2.25,2.25,0,0,1,14.068,12.1ZM26.455,26.221a.577.577,0,0,0,.388-1L14.456,13.93a.571.571,0,0,0-.777,0L1.292,25.217a.577.577,0,0,0,.389,1H4.5v12.12h6.736V30.663H16.9v7.678h6.736V26.221Z",
    transform: "translate(0.576 -12.101)",
    fill: "#65676a"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11946",
    "data-name": "Group 11946",
    transform: "translate(22.519 6.047)",
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11945",
    "data-name": "Group 11945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5535",
    "data-name": "Path 5535",
    d: "M349.742,42.73h-5.769l6.628,6.027V43.589A.859.859,0,0,0,349.742,42.73Z",
    transform: "translate(-343.973 -42.73)",
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.c9c1e65ba4d5e6d3b67302c331414b06.svg";
export { ForwardRef as ReactComponent };